module.exports = __webpack_public_path__ + "media/images/emblems/Trub-coat_of_arms-0d9de532ca40d5ccd7ddf9538d3de89f.svg";